import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';

import { FilterInterface } from '../../../shared/filter-bar/filter-bar.component';
import { GetResourcesLvl2GQL } from '../../../../generated/graphql';

@Component({
  selector: 'app-resources-lvl2-table',
  templateUrl: './resources-lvl2-table.component.html',
  styleUrls: ['./resources-lvl2-table.component.scss']
})
export class ResourcesLvl2TableComponent implements OnInit {
  metricGroups = [];
  initDates;
  filterCache;
  isDatePickerClosed: boolean;
  isLoading = false;

  @Input() card;
  @Input() dashboardId: string;

  constructor(
    private getResourcesLvl2: GetResourcesLvl2GQL
  ) {}

  ngOnInit(): void {
    this.initDates = {
      dateRange: {
        dateFrom: moment(),
        dateTo: moment().add(14, 'days')
      }
    };
    this.onFilterChanges(this.initDates)
  }

  loadData(dateFrom, dateTo): void {
    if (!this.card?.id || !this.dashboardId) {
      return;
    }
    this.isLoading = true;
    this.getResourcesLvl2.fetch({ id: this.card.id, dashboardId: this.dashboardId, dateFrom, dateTo }).subscribe(val => {
      this.metricGroups = [...val.data.metricGroupsAssignment.edges];
      this.isLoading = false;
    }, () => this.isLoading = false);
  }

  // getLastWorkingDay(date) {
  //   let lastWorkingDay;
  //
  //   switch (date.isoWeekday()) {
  //     case 1:
  //       lastWorkingDay = date.subtract(3, 'days');
  //       break;
  //     case 6:
  //       lastWorkingDay = date.subtract(1, 'days');
  //       break;
  //     case 7:
  //       lastWorkingDay = date.subtract(2, 'days');
  //       break;
  //     default:
  //       lastWorkingDay = date.subtract(1, 'days');
  //       break;
  //   }
  //
  //   return lastWorkingDay;
  // }

  onFilterChanges(filters: FilterInterface) {
    const dateRange = filters.dateRange;
    const cachedRange = this.filterCache?.dateRange;

    this.isDatePickerClosed = !!(
      !this.filterCache || (dateRange.dateFrom.isSame(cachedRange.dateFrom) && (!cachedRange.dateTo && dateRange.dateTo))
    );

    this.filterCache = filters;

    if ((this.isDatePickerClosed) && dateRange && (dateRange.dateFrom && dateRange.dateTo)) {
      this.loadData(
        dateRange.dateFrom ? moment(dateRange.dateFrom).format('YYYY-MM-DD') : null,
        dateRange.dateTo ? moment(dateRange.dateTo).format('YYYY-MM-DD') : null
      );
    }
  }

}
